<script>
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: {
    NextButton,
  },
  props: {
    totalLength: {
      type: Number,
      default: 0,
    },
    currentIndex: {
      type: Number,
      default: 0,
    },
  },
  emits: ['prev', 'next'],
  computed: {
    isUpDisabled() {
      return this.currentIndex === 1;
    },
    isDownDisabled() {
      return this.currentIndex === this.totalLength || this.totalLength <= 1;
    },
  },
  methods: {
    handleUpClick() {
      if (this.currentIndex > 1) {
        this.$emit('prev');
      }
    },
    handleDownClick() {
      if (this.currentIndex < this.totalLength) {
        this.$emit('next');
      }
    },
  },
};
</script>

<template>
  <div class="flex gap-2 items-center">
    <div class="flex gap-1 items-center">
      <NextButton
        v-tooltip.bottom="$t('INBOX.WORKSPACE.PREVIOUS')"
        icon="i-lucide-chevron-up"
        xs
        slate
        faded
        :disabled="isUpDisabled"
        @click="handleUpClick"
      />
      <NextButton
        v-tooltip.bottom="$t('INBOX.WORKSPACE.NEXT')"
        icon="i-lucide-chevron-down"
        xs
        slate
        faded
        :disabled="isDownDisabled"
        @click="handleDownClick"
      />
    </div>
    <span class="text-sm font-medium text-n-slate-11 tabular-nums">
      {{
        totalLength > 1
          ? $t('INBOX.WORKSPACE.POSITION', {
              current: currentIndex,
              total: totalLength,
            })
          : $t('INBOX.WORKSPACE.SINGLE_POSITION')
      }}
    </span>
  </div>
</template>
